const getReactInputData = (): { [key: string]: any } | null => {
  const reactDataContainer = document.getElementById("react_input_data");
  if (reactDataContainer) {
    try {
      return JSON.parse(reactDataContainer.innerText);
    } catch (e) {
      console.error("Failed to parse react_input_data", e);
      return null;
    }
  }
  return null;
};

export const getStaticAssetUrl = (path: string): string => {
  const pageData = getReactInputData();
  const staticAssetDomain = pageData?.static_asset_domain;

  const sanitizedPath = path.startsWith("/") ? path.substring(1) : path;

  if (staticAssetDomain) {
    return `https://${staticAssetDomain}/${sanitizedPath}`;
  }

  return `/static/${sanitizedPath}`;
};

export default getStaticAssetUrl;
